var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-autocomplete", {
    staticClass: "ma-0",
    attrs: {
      items: _vm.userStoreParties,
      "background-color": "input",
      dense: "",
      "item-text": "party_name",
      "item-id": "party_id",
      label: "Store Group / Store",
      "menu-props": { maxHeight: 300 },
      outlined: "",
      "return-object": "",
      "hide-details": "",
    },
    on: { change: _vm.updateStoreGroup },
    model: {
      value: _vm.storeParty,
      callback: function ($$v) {
        _vm.storeParty = $$v
      },
      expression: "storeParty",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }